import {Component, NgZone, OnInit} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {GlobalService} from './global.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(private router: Router, private globalService: GlobalService, private zone: NgZone) {
    if (this.globalService.isBrwoser) {
      this.globalService.domain = window.location.origin;
      this.zone.runOutsideAngular(() => {
        const loadCountries = require('../assets/countries.json');
        this.globalService.countries.next(loadCountries);

      });
    }
  }


  ngOnInit() {
    console.log('GBarena 1...');
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        if (evt.url.indexOf('?fbclid') !== -1) {
          this.router.navigateByUrl(evt.url.split('?fbclid')[0]);
        }
      }
    });
  }

}
